export default function useSection (page) {
  const getSection = name => page.sections.find(section => section.name.includes(name))
  const getSectionAttributes = name => getSection(name)?.attributes
  const isVisible = name => getSection(name)?.is_visible

  return { getSection, getSectionAttributes, isVisible }
}